import { Button, Container, Grid, GridColumn, GridRow, Icon } from "semantic-ui-react";
import styles from './TourPage.module.css';
import { useState } from "react";
import TourForm from "./TourForm";
import { useNavigate } from "react-router-dom";

const TourPage = () => {
    const [showForm, setShowForm] = useState(false);

    const onShowFormClick = () => {
        setShowForm(true);
    }

    const onWhatsupClick = (text: string) => {
        let path = `https://wa.me/994512515100?text=${text.replaceAll(' ', '%20')}`;
        window.location.href = path;
    }

    return (
        <>
            <div className={styles.hero}>
                <img src="/assets/ex.jpeg" style={{ minWidth: 768 }} />
                <div className={styles.herotext}>
                    <h1>Трюфельная охота</h1>
                    <p></p>
                </div>
            </div>
            <Container>
                <section id="program"><h2>Программа трюфельной охоты</h2></section>

                <img src="/assets/4.jpeg" alt="Truffles' tour" className={styles.img2} />

                <p>Утром мы встречаемся в Вашем отеле, надеваем спец одежду.</p>

                <p>Форма одежды в день охоты рекомендуется "дачная" - дождевики и спортивные куртки. Резиновые сапоги можно арендовать у нас.</p>
                <p>Неподготовленный человек не способен найти подземный гриб самостоятельно, для этого ему нужен друг - специально обученная собака, родители которой занимались поиском трюфелей из поколения в поколение - это лаготто романьоло и коккер спаниель.</p>
                <p>Для охоты на трюфеля нужно обладать определенными знаниями и ведать секретами бывалых охотников. </p>
                <p>Mы отправимся в частный лес на 3-х часовую охоту, где другие охотники не имеют права вступать на территорию.</p>

                <p>Bам расскроют секреты трюфельной охоты и покажут сам процесс поиска трюфелей.</p>
                <p>Вы узнаете как формируется трюфель, научитесь находить и различать грибы, аккуратно извлекать их из земли, правильно выбирать трюфели, которые встречаются на ярмарках и рынках.</p>

                <p>По желанию найденные трюфеля можно приобрести у охотника по льготной цене.</p>

                <p>По окончанию трюфельной охоты вы становитесь Мэмбэр (членом клуба трюфельных охотников). Награждение проходит в ресторане нашего клуба, где вам предоставляется аперитив: яичница с трюфелями + кофе с трюфелем.
                    Это входит в цену экскурсии.
                </p>
                <Grid>
                    <GridRow>
                        <GridColumn>
                            <section className={styles.priceTable}>
                                <header className={styles.priceTable__header}>
                                    <h1 className={styles.priceTable__title}>Групповой формат</h1>
                                </header>
                                <table width={300} className={styles.priceTable__table}>
                                    <tbody>
                                        <tr>
                                            <td>Длительность</td>
                                            <td>3 Часа</td>
                                        </tr>
                                        <tr>
                                            <td>Размер группы</td>
                                            <td>до 12 человек </td>
                                        </tr>
                                        <tr>
                                            <td>Дети</td>
                                            <td>Можно с детьми</td>
                                        </tr>
                                        <tr>
                                            <td>Как проходит</td>
                                            <td>пешком</td>
                                        </tr>
                                        <tr><td className={styles.biginfo} colSpan={2}><span className={styles.price}>150 </span></td></tr>
                                        {/* {(!showForm) && <tr><td className={styles.biginfo} colSpan={2}>
                                            <Button onClick={onShowFormClick} type='button' color='google plus' icon labelPosition='left' size='small'>
                                                <Icon name='search plus' />
                                                заказать тур
                                            </Button>
                                        </td></tr>} */}
                                        <tr><td className={styles.biginfo} colSpan={2}>
                                            <Button onClick={x => onWhatsupClick("Заказать тур")} type='button' color='green' icon labelPosition='left' size='small'>
                                                <Icon name='whatsapp' />
                                                заказать тур
                                            </Button>
                                        </td></tr>
                                    </tbody>
                                </table>
                            </section>

                        </GridColumn>
                        {/* <GridColumn>
                            {showForm && <section><TourForm setShowForm={setShowForm} /></section>}

                        </GridColumn> */}
                    </GridRow>
                </Grid>

            </Container >
        </>
    );
}

export default TourPage